/* @ngInject */
export default class DropdownController {
  public isDropdownOpened = false;
  public choosenItem: string;
  public callFn;
  public list;
  public defaultItem;
  private $scope;
  constructor($scope) {
    this.$scope = $scope;
  }

  public $onInit() {
    this.choosenItem = this.defaultItem || this.list[0];
  }

  private outsideClick = ev => {
    if (
      !(
        ev.target.classList.contains('dropdown-head') ||
        ev.target.parentElement.classList.contains('dropdown-body__item') ||
        ev.target.classList.contains('dropdown-body__item')
      )
    ) {
      this.isDropdownOpened = false;
      this.$scope.$digest();
    }
  };

  public toggleDropDown() {
    this.isDropdownOpened = !this.isDropdownOpened;
    this.isDropdownOpened
      ? document.body.addEventListener('click', this.outsideClick)
      : document.body.removeEventListener('click', this.outsideClick);
  }

  public chooseDropDownItem(clickedItem) {
    this.callFn(clickedItem);
    this.choosenItem = clickedItem;
    this.toggleDropDown();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dropdown/dropdown.controller.ts